import styled, { css } from "styled-components";

export const RunnerInfoContainer = styled.div`
  width: 100%;
`;

export const RunnerInfoHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const RunnerInfoTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.bold};
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
`;

export const RunnerInfoShowMoreLink = styled.button`
  margin-left: 8px;
  white-space: nowrap;
  font-family: ${({ theme }) => theme.fonts.medium};
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: ${({ theme }) =>
    theme.colorTokens.component.button.buttonLink.content.base};
  background-color: transparent;
  outline: none;
  cursor: pointer;
`;

export const RunnerMainInfo = styled.span`
  color: ${({ theme }) => theme.colorTokens.content.subtle};
  font-family: ${({ theme }) => theme.fonts.regular};
  font-style: normal;
  font-weight: normal;
  line-height: 18px;
`;

export const RunnerFlagsContainer = styled.div`
  margin-top: 12px;
`;

export const RunnerComplementaryInfo = styled.div<{
  isVisible: boolean;
  smallPadding?: boolean;
}>`
  transition: max-height 200ms ease-in-out;
  ${({ isVisible }) =>
    isVisible
      ? css`
          max-height: 1000px;
        `
      : css`
          max-height: 0;
          overflow: hidden;
        `}

  &::before {
    visibility: ${({ isVisible }) => (isVisible ? "visible" : "hidden")};
    margin: ${({ smallPadding }) =>
      smallPadding ? "12px -12px 8px 0px" : "12px -12px 12px 0px"};
    content: " ";
    display: block;
    border-bottom: 1px solid ${({ theme }) => theme.colorTokens.border.default};
  }
`;

export const ComplementaryInfo = styled.div`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ComplementaryInfoLabel = styled.span`
  display: inline-block;
  width: 55px;
  font-family: ${({ theme }) => theme.fonts.medium};
  font-weight: 500;
  line-height: 19px;
  vertical-align: top;
  font-size: 14px;
  text-transform: capitalize;
  color: ${({ theme }) => theme.colorTokens.content.default};
`;

export const ComplementaryInfoValue = styled.span<{ hasChanges: boolean }>`
  font-size: 14px;
  text-transform: capitalize;
  max-width: calc(100% - 76px);
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: ${({ theme }) => theme.fonts.regular};
  line-height: 18px;
  vertical-align: top;
  color: ${({ theme }) => theme.colorTokens.content.subtle};
  ${({ hasChanges, theme }) =>
    hasChanges
      ? css`
          margin-left: 8px;
          font-family: ${theme.fonts.medium};
          font-weight: 500;
          line-height: 19px;
          color: ${theme.colorTokens.content.alert};
        `
      : css`
          margin-left: 19px;
          font-family: ${theme.fonts.regular};
          font-weight: normal;
          line-height: 18px;
        `};
`;

export const IconContainer = styled.div`
  display: inline-block;
  height: 12px;
  width: 12px;
  color: ${({ theme }) => theme.colorTokens.content.alert};
  border: ${({ theme }) => `1.5px solid ${theme.colorTokens.content.default}`};
  border-radius: 1px;
  transform: rotate(45deg);

  .icon-transformation {
    position: absolute;
    top: -36%;
    left: -36%;
    transform: rotate(-45deg);
  }
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: -36%;
  left: -36%;
  transform: rotate(-45deg);
`;
